var map = {
	"./agreement.png": "42b9",
	"./icon_arrow_primary.png": "338d",
	"./icon_result_error.png": "efc8",
	"./icon_result_success.png": "95fb",
	"./icon_result_wait.png": "3f59",
	"./infor.png": "78f9",
	"./institution.png": "205d",
	"./list.png": "78d4",
	"./notes.png": "c961",
	"./order.png": "87aa",
	"./power.png": "85ab",
	"./report.png": "597a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";